module.exports = __webpack_public_path__ + "static/media/18.50de495a.jpg";